import { FormEvent, useState } from "react";
import { api, ApiError } from "../api/client";

const brandLogo = `${import.meta.env.BASE_URL}brand/aviza-logo.png`;

export function LoginPage({ onLoggedIn }: { onLoggedIn: () => void }) {
  const [error, setError] = useState("");
  const [mode, setMode] = useState<"login" | "forgot">("login");
  const [forgotSent, setForgotSent] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    setError("");
    try {
      await api("/api/admin/auth/login", {
        method: "POST",
        body: JSON.stringify({
          email: form.get("email"),
          password: form.get("password"),
          website: form.get("website")
        })
      });
      onLoggedIn();
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) {
        setError("Neispravni kredencijali.");
        return;
      }
      setError(await serverStatusMessage());
    }
  }

  async function submitForgotPassword(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    setError("");
    setForgotSent(false);
    try {
      await api("/api/admin/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify({
          email: form.get("email"),
          website: form.get("website")
        })
      });
      setForgotSent(true);
    } catch {
      setError("Zahtjev nije poslat. Pokusajte ponovo za nekoliko minuta.");
    }
  }

  if (mode === "forgot") {
    return (
      <main className="login-shell">
        <form className="login-panel" onSubmit={submitForgotPassword}>
          <div className="brand login-brand">
            <img className="brand-logo" src={brandLogo} alt="" aria-hidden="true" />
            <span>Aviza</span>
          </div>
          <h1 className="login-title">Reset lozinke</h1>
          <p className="login-copy">unesite email nalog. Ako nalog postoji, poslaćemo link za promjenu lozinke.</p>
          <label>
            Email
            <input name="email" type="email" autoComplete="email" required autoFocus />
          </label>
          <input className="bot-field" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" />
          {forgotSent && <p className="form-success">Ako postoji nalog sa tim emailom, reset link je poslat.</p>}
          {error && <p className="form-error">{error}</p>}
          <button type="submit">Pošalji reset link</button>
          <button className="link-button" type="button" onClick={() => { setMode("login"); setError(""); setForgotSent(false); }}>
            Nazad na prijavu
          </button>
        </form>
      </main>
    );
  }

  return (
    <main className="login-shell">
      <form className="login-panel" onSubmit={submit}>
        <div className="brand login-brand">
          <img className="brand-logo" src={brandLogo} alt="" aria-hidden="true" />
          <span>Aviza</span>
        </div>
        <label>
          Email
          <input name="email" type="email" autoComplete="email" required />
        </label>
        <label>
          Lozinka
          <input name="password" type="password" autoComplete="current-password" required />
        </label>
        <input className="bot-field" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" />
        {error && <p className="form-error">{error}</p>}
        <button type="submit">Prijava</button>
        <button className="link-button" type="button" onClick={() => { setMode("forgot"); setError(""); }}>
          Zaboravili ste lozinku?
        </button>
      </form>
    </main>
  );
}

async function serverStatusMessage() {
  try {
    const status = await api<{
      database?: { host: string; port: number; open: boolean };
      redis?: { host: string; port: number; open: boolean };
    }>("/api/dev/status");
    if (status.database && !status.database.open) {
      return `Baza nije dostupna na ${status.database.host}:${status.database.port}. Pokreni Postgres pa pnpm prisma:migrate i pnpm prisma:seed.`;
    }
    if (status.redis && !status.redis.open) {
      return `Redis nije dostupan na ${status.redis.host}:${status.redis.port}. Admin login trazi bazu; worker/alerti traze Redis.`;
    }
  } catch {
    return "Server ili baza nisu spremni. Pokreni pnpm dev:check.";
  }
  return "Server ili baza nisu spremni. Pokreni pnpm dev:check.";
}
